/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Picker_All_GroupInputs */

const vi_product_picker_all_group = /** @type {(inputs: Product_Picker_All_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả sản phẩm`)
};

/**

* @param {Product_Picker_All_GroupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_picker_all_group = /** @type {((inputs?: Product_Picker_All_GroupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Picker_All_GroupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_picker_all_group(inputs)
});